import { HistoryMessageSegment } from "types/historyMessageTypes";

/**
 * Builds formatted message for NOTE history type
 * Add implementation when product owner defines format
 */
export class NoteMessageBuilder {
  static build(note: any): HistoryMessageSegment[] {
    // TODO: Define format for NOTE type
    return [];
  }
}
